import React, { useState } from 'react';
import { PHOTO_PATH } from '../constants';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await onLogin(username, password);
    } catch (err) {
      setError(err.message || 'Invalid Username or Password / अवैध वापरकर्ता नाव किंवा पासवर्ड');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-card">
      <div className="login-header">
        <img
          src={PHOTO_PATH}
          alt="Gopinath Munde"
          className="login-photo"
        />
        <div>
          <h2>Surveyor Login / सर्वेक्षक लॉगिन</h2>
          <p className="login-subtitle">Enter your credentials to access the portal<br/>पोर्टलमध्ये प्रवेश करण्यासाठी तुमची क्रेडेंशियल्स प्रविष्ट करा</p>
        </div>
      </div>

      {error && <div className="error-msg">{error}</div>}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Username (Contact Number or Email) / वापरकर्ता नाव (संपर्क क्रमांक किंवा ईमेल)</label>
          <input
            type="text"
            placeholder="Enter contact number or email / संपर्क क्रमांक किंवा ईमेल प्रविष्ट करा"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>

        <div className="form-group">
          <label>Password (Surveyor DOB) / पासवर्ड (सर्वेक्षक जन्मतारीख)</label>
          <input
            type="password"
            placeholder="Enter your date of birth / तुमची जन्मतारीख प्रविष्ट करा"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn-primary" disabled={loading}>
          {loading ? 'Authenticating... / प्रमाणीकरण करत आहे...' : 'Login / लॉगिन'}
        </button>
      </form>
    </div>
  );
}

export default Login;
